module.exports = __webpack_public_path__ + "static/rabies1-0e9952a2c7400f2b824dd8c2fccd600d.png";